import { render, staticRenderFns } from "./TripsDashboard.vue?vue&type=template&id=385faf77&scoped=true"
import script from "./TripsDashboard.vue?vue&type=script&lang=js"
export * from "./TripsDashboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "385faf77",
  null
  
)

export default component.exports